(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityTemplatePreviewFields', drvEntityTemplatePreviewFields);

    drvEntityTemplatePreviewFields.$inject = [];
    EntityTemplatePreviewFieldsCtrl.$inject = ['FieldSelectorService', 'DialogService'];
    
    /**
     * For editing the fields included in the entity template "Preview Fields".
     */
    function drvEntityTemplatePreviewFields() {
        var directive = {
            link: link,
            restrict: 'E',
            bindToController: true,
            controller: EntityTemplatePreviewFieldsCtrl,
            controllerAs: 'vm',
            scope: {
                entityTemplate: '<'
            },
            templateUrl: 'app/EntityTemplate/entity-template-preview-fields.tmpl.html'
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    function EntityTemplatePreviewFieldsCtrl(FieldSelectorService, DialogService) {
        var vm = this;
        vm.addPreviewField = addPreviewField;
        vm.formatFieldExpression = formatFieldExpression;
        vm.entityPreviewFieldDragListener = {
            accept: dragDropAccept,
            containment: '#previewFieldsList'
        };


        /**
         * Determine whether an item being dropped in the drag-drop should be accepted.
         */
        function dragDropAccept(sourceItemHandleScope, destSortableScope) {
            return angular.isDefined(sourceItemHandleScope.sortableScope.element[0]) &&
                sourceItemHandleScope.sortableScope.element[0].id === 'assignedPreviewField';
        }

        /**
         * Display dialog for choosing fields to be included in "Preview Fields".
         */
        function addPreviewField() {
            FieldSelectorService.displayDialogForEntityTemplate(
                vm.entityTemplate, {
                    multiSelect: true,
                    fieldFormatter: FieldSelectorService.fieldFormatters.entityPreview,
                    selectedFields: vm.entityTemplate.PreviewFields
                }
            ).then(
                fieldSelectorOk,
                fieldSelectorError);

            function fieldSelectorOk(selectedFields) {
                // Remove fields that are no longer part of the selection
                _.remove(vm.entityTemplate.PreviewFields, function (existingPreviewField) {
                    return _.indexOf(selectedFields, existingPreviewField) === -1;
                });

                // Add fields that are new additions to the selection
                _.forEach(selectedFields, function (field) {
                    if (_.indexOf(vm.entityTemplate.PreviewFields, field) === -1) {
                        vm.entityTemplate.PreviewFields.push(field);
                    }
                });
            }

            function fieldSelectorError(error) {
                if (!_.isNil(error)) {
                    DialogService.error(error);
                }
            }
        }

        /**
         * Convert the field expression to a format that's much nicer to look at.
         * E.g. "Cats > Species" instead of "['Cats'][*]['Species']"
         *
         * @param {string} fieldExpression
         * @returns {string}
         */
        function formatFieldExpression(fieldExpression) {
            var fieldNames = FieldSelectorService.fieldFormatters.entityPreview.convertExpressionToFieldNames(fieldExpression);
            return fieldNames.join(' > ');
        }
    }
})();